import { pipe } from 'fp-ts/function';
import { useCallback } from 'react';
import { PlatformProfilePrivileges } from '@mews-commander/data-access';
import { useLocalizeOption } from '@mews-commander/form';
import { omitFalsyValues } from '@mews/fp';
import { upperFirst } from '@mews/std';

export type PlatformProfilePrivilegesFlag = keyof PlatformProfilePrivileges;

export const parsePlatformProfilePrivilegesToArray = (
    data: Partial<PlatformProfilePrivileges>
): PlatformProfilePrivilegesFlag[] => pipe(data, omitFalsyValues, Object.keys) as PlatformProfilePrivilegesFlag[];

const PRIVILEGE_KEY_PREFIX = 'PlatformProfilePrivileges';

export const useLocalizePlatformProfilePrivilege = () => {
    const localizeOption = useLocalizeOption();
    return useCallback(
        (privilege: PlatformProfilePrivilegesFlag) => localizeOption(PRIVILEGE_KEY_PREFIX, upperFirst(privilege)),
        [localizeOption]
    );
};
